import { supabase } from "@/integrations/supabase/client";

const ENTITY_IMAGES_BUCKET = "entity-images";
const PLACEHOLDER_IMAGE = "/placeholder.svg";

export function getStorageUrl(path?: string | null): string {
  if (!path) {
    return PLACEHOLDER_IMAGE;
  }

  // If it's already an absolute URL (e.g. Supabase public URL), return as-is
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // If someone stored "entity-images/filename.jpg", strip the bucket prefix
  const cleanedPath = path.replace(/^entity-images\//, "");

  const { data } = supabase.storage
    .from(ENTITY_IMAGES_BUCKET)
    .getPublicUrl(cleanedPath);

  // Fallback to placeholder if something went wrong
  return data?.publicUrl || PLACEHOLDER_IMAGE;
}
